function getValue(e,u){return null==e?void 0:e[u]}module.exports=getValue;